import { toast } from "react-toastify";
import { redirectToPortalWebLogout } from "../../../common/utils/portalWebLogout";

interface Props {
    deleteEmployee: (params: { id: number }) => {
        unwrap: () => Promise<unknown>;
    };
    employeeId: number;
    idToken?: string;
}

export const handleDeleteEmployee = async (props: Props): Promise<void> => {
    try {
        await props.deleteEmployee({ id: props.employeeId }).unwrap();
        redirectToPortalWebLogout(props.idToken);
    } catch (error) {
        console.error(error);
        toast.error("Er is iets misgegaan");
    }
};
